(() => {
  if (window.FOHCareCodexInit) return;
  window.FOHCareCodexInit = true;

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-foh-open-tawk]');
    if (!trigger) return;
    if (window.Tawk_API && typeof window.Tawk_API.maximize === 'function') {
      window.Tawk_API.maximize();
      return;
    }
    trigger.setAttribute('aria-live', 'polite');
    trigger.textContent = 'Chat is loading...';
    setTimeout(() => {
      if (window.Tawk_API && typeof window.Tawk_API.maximize === 'function') {
        window.Tawk_API.maximize();
        trigger.textContent = trigger.dataset.originalLabel || 'Open Support Chat';
      } else {
        trigger.textContent = 'Chat widget unavailable';
      }
    }, 900);
  });

  document.querySelectorAll('[data-foh-open-tawk]').forEach((button) => {
    button.dataset.originalLabel = button.textContent.trim();
  });


  const setupMobileSpineMove = () => {
    const spine = document.querySelector('[data-foh-care-spine]');
    const mobileAnchor = document.querySelector('[data-foh-care-spine-mobile-anchor]');
    if (!spine || !mobileAnchor) return;

    const originalParent = spine.parentNode;
    const originalNextSibling = spine.nextSibling;
    const mq = window.matchMedia('(max-width: 989px)');

    const moveSpine = () => {
      if (mq.matches) {
        if (spine.parentNode !== mobileAnchor) {
          mobileAnchor.hidden = false;
          mobileAnchor.appendChild(spine);
        }
      } else {
        if (spine.parentNode !== originalParent) {
          if (originalNextSibling && originalNextSibling.parentNode === originalParent) {
            originalParent.insertBefore(spine, originalNextSibling);
          } else {
            originalParent.appendChild(spine);
          }
        }
        mobileAnchor.hidden = true;
      }
    };

    moveSpine();
    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', moveSpine);
    } else if (typeof mq.addListener === 'function') {
      mq.addListener(moveSpine);
    }
  };

  setupMobileSpineMove();

  const input = document.querySelector('[data-foh-care-search]');
  if (!input) return;

  const clearButton = document.querySelector('[data-foh-care-clear]');
  const status = document.querySelector('[data-foh-care-search-status]');
  const resultsBox = document.querySelector('[data-foh-care-search-results]');
  const noResults = document.querySelector('[data-foh-care-no-results]');
  const categories = Array.from(document.querySelectorAll('[data-foh-care-category]'));
  const faqs = Array.from(document.querySelectorAll('[data-foh-care-faq]'));

  const normalize = (value) => (value || '')
    .toString()
    .toLowerCase()
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9\s-]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

  const synonyms = {
    order: 'shipping shipped tracking delivery package carrier where is my order missing damaged status',
    shipping: 'order shipped delivery tracking package carrier usps ups mail customs international turnaround',
    tracking: 'where is my order shipped delivery package carrier status',
    download: 'stl files digital file link email zip svg printable download again',
    stl: '3d printable download file license merchant commercial print printing files',
    decal: 'transfer waterslide icon chapter availability restock discontinued fleur sheet',
    decals: 'transfer waterslide icon chapter availability restock discontinued fleur sheet',
    stencil: 'airbrush mask paint vinyl reusable bleeding camo pattern apply',
    stencils: 'airbrush mask paint vinyl reusable bleeding camo pattern apply',
    return: 'refund exchange cancel damaged wrong item buyer remorse eligibility',
    refund: 'return exchange cancel damaged wrong item buyer remorse money back',
    payment: 'pay card checkout promo coupon discount code charged paypal bank',
    promo: 'coupon discount code sale gift voucher payment promotion',
    license: 'merchant commercial personal use stl pod sell prints permission',
    customs: 'international tariff duty vat import delivery shipping'
  };

  const expandTerm = (term) => {
    const words = normalize(term).split(' ').filter(Boolean);
    const expanded = [...words];
    words.forEach((word) => {
      if (synonyms[word]) expanded.push(...synonyms[word].split(' '));
    });
    return Array.from(new Set(expanded)).filter((word) => word.length > 1);
  };

  const setStatus = (message) => {
    if (status) status.textContent = message;
  };

  const getSectionWrapper = (category) => category.closest('.foh-care-codex-entries');

  const showAll = () => {
    categories.forEach((category) => {
      category.hidden = false;
      category.open = true;
      const wrapper = getSectionWrapper(category);
      if (wrapper) wrapper.hidden = false;
    });
    faqs.forEach((faq) => {
      faq.hidden = false;
      faq.open = false;
    });
    if (clearButton) clearButton.hidden = true;
    if (resultsBox) {
      resultsBox.hidden = true;
      resultsBox.innerHTML = '';
    }
    if (noResults) noResults.hidden = true;
    setStatus('');
  };

  const openResult = (faq) => {
    const category = faq.closest('[data-foh-care-category]');
    if (category) {
      category.hidden = false;
      category.open = true;
      const wrapper = getSectionWrapper(category);
      if (wrapper) wrapper.hidden = false;
    }
    faq.hidden = false;
    faqs.forEach((item) => { if (item !== faq) item.open = false; });
    faq.open = true;
    requestAnimationFrame(() => {
      faq.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  };

  const renderResults = (matches, rawTerm) => {
    if (!resultsBox) return;
    if (!rawTerm || rawTerm.length < 2 || !matches.length) {
      resultsBox.hidden = true;
      resultsBox.innerHTML = '';
      return;
    }

    const limited = matches.slice(0, 8);
    const list = document.createElement('div');
    list.className = 'foh-care-codex__result-list';

    limited.forEach((faq) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'foh-care-codex__result-link';
      button.dataset.targetId = faq.id;

      const question = document.createElement('span');
      question.className = 'foh-care-codex__result-question';
      question.textContent = faq.dataset.question || faq.querySelector('summary span')?.textContent?.trim() || 'Customer care entry';

      const category = document.createElement('span');
      category.className = 'foh-care-codex__result-category';
      category.textContent = faq.dataset.categoryTitle || '';

      button.appendChild(question);
      button.appendChild(category);
      list.appendChild(button);
    });

    resultsBox.innerHTML = '';
    resultsBox.appendChild(list);
    resultsBox.hidden = false;
  };

  const applySearch = () => {
    const rawTerm = input.value.trim();
    const searching = rawTerm.length >= 2;
    if (!searching) {
      showAll();
      return;
    }

    const tokens = expandTerm(rawTerm);
    let visibleFaqs = 0;
    const matches = [];

    categories.forEach((category) => {
      const categoryText = normalize(`${category.dataset.categoryTitle || ''} ${category.textContent || ''}`);
      const categoryFaqs = Array.from(category.querySelectorAll('[data-foh-care-faq]'));
      let categoryVisible = false;

      categoryFaqs.forEach((faq) => {
        const haystack = normalize(`${faq.dataset.searchText || ''} ${faq.dataset.categoryTitle || ''}`);
        const match = tokens.some((token) => haystack.includes(token)) || tokens.some((token) => categoryText.includes(token));
        faq.hidden = !match;
        faq.open = false;
        if (match) {
          categoryVisible = true;
          visibleFaqs += 1;
          matches.push(faq);
        }
      });

      category.hidden = !categoryVisible;
      category.open = categoryVisible;
      const wrapper = getSectionWrapper(category);
      if (wrapper) wrapper.hidden = !categoryVisible;
    });

    if (clearButton) clearButton.hidden = false;
    if (noResults) noResults.hidden = visibleFaqs > 0;
    renderResults(matches, rawTerm);

    if (visibleFaqs > 0) {
      const shown = Math.min(visibleFaqs, 8);
      setStatus(`${visibleFaqs} matching ${visibleFaqs === 1 ? 'entry' : 'entries'} found. ${shown} quick ${shown === 1 ? 'link' : 'links'} shown below.`);
    } else {
      setStatus('No matching entries found. Try order, shipping, download, STL, decal, stencil, refund, payment, or license.');
    }
  };

  input.addEventListener('input', applySearch);
  if (clearButton) {
    clearButton.addEventListener('click', () => {
      input.value = '';
      input.focus();
      showAll();
    });
  }

  if (resultsBox) {
    resultsBox.addEventListener('click', (event) => {
      const button = event.target.closest('[data-target-id]');
      if (!button) return;
      const target = document.getElementById(button.dataset.targetId);
      if (target) openResult(target);
    });
  }
})();
